export default "__VITE_ASSET__CEYx_j9C__"